export default __webpack_public_path__ + "static/media/grapes.28f7dfe1.jpg";